import { render } from "./GalleriaItem.vue?vue&type=template&id=4a356874"
import script from "./GalleriaItem.vue?vue&type=script&lang=js"
export * from "./GalleriaItem.vue?vue&type=script&lang=js"
script.render = render

export default script